export default __webpack_public_path__ + "static/media/carvana-little-city.fbc21a48.svg";